import React, { useEffect } from "react";
import { useMapEvent } from "react-leaflet";
import { useMap } from "Utils/hooks";
import LeafletPlaceholders from "./leafletPlaceholders";
import LeafletWrapper from "./leafletWrapper";

const LeafletMap = () => {
  return (
    <LeafletWrapper>
      <LocationHandler />
      <LeafletPlaceholders />
    </LeafletWrapper>
  );
};

export default LeafletMap;

const LocationHandler = () => {
  const { setGeolocation, configuration } = useMap();
  const map = useMapEvent("locationfound", (e) => {
    setGeolocation(e.latlng);
    // map.flyTo(e.latlng, 13);
  });

  useEffect(() => {
    if (configuration?.geolocation) {
      map.locate({
        watch: true,
        timeout: 100000,
        maximumAge: 10000,
        enableHighAccuracy: true,
      });
    }
    return () => map.stopLocate();
  }, [configuration?.geolocation]);
};
